import * as React from 'react';

type ExerciseRequirements =
  "goalkeepersWarmup" |
  "otherPlayersWarmup" |
  "drillOne" |
  "drillTwo" |
  "drillThree" |
  "drillFour" |
  "drillFive" |
  "drillSix" |
  "drillSeven" |
  "drillEight" |
  "drillNine" |
  "drillTen" |
  "drillEleven" |
  "drillTwelve" |
  "drillThirteen" |
  "drillFourteen";

interface FormattedRequirementProps {
  exercise: ExerciseRequirements;
}

const requirements = {
  goalkeepersWarmup: {
    equipmentRequired: 'TRS; football.',
    participantNumber: 'Two.',
    suitability: 'ALL standards.',
    areaRequired: 'Three metres wide to allow for the screen and five metres either side of the screen.',
    focus: 'To progress through simple general skills functions in preparation for more complex drills.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching, stopping the ball.',
    setUp: 'Players stand facing each other either side of the TRS. Each player stands approximately four metres from the TRS.'
  },
  otherPlayersWarmup: {
    equipmentRequired: 'TRS; football.',
    participantNumber: 'Two to four.',
    suitability: 'ALL standards',
    areaRequired: 'Up to ten metres wide to allow for the screen and five metres either side of the screen.',
    focus: 'To progress through simple general skills functions in preparation for more complex drills.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, stopping the ball, passing the ball.',
    setUp: 'Players stand facing each other either side of the TRS. Each player stands approximately four metres from the TRS.'
  },
  drillOne: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus one.',
    suitability: 'All standards.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To acquaint the goalkeeper with the reduction in available reaction time because of restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination.',
    setUp: 'TRS is set up 15 to 20 metres in front of goal. Goalkeeper stands in front of goal. Attacker stands other side of TRS.'
  },
  drillTwo: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus three.',
    suitability: 'All standards.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To acquaint the goalkeeper with the reduction in available reaction time because of restricted vision. To assist striker with awareness of target size through restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination, blocking, kicking both feet, spacial awareness.',
    setUp: 'TRS is set up 15 to 20 metres in front of goal. Goalkeeper stands in front of goal. A stands other side of TRS. B and C stand about 10 metres either side of A in plain sight of the goalkeeper.'
  },
  drillThree: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus one.',
    suitability: 'More advanced.  Attacker must be able to curve the ball.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'Striker to judge curving the ball.  Goalkeeper to defend with the reduction in available reaction time because of restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination, ball striking with each foot curving the ball around the screen and back into the goal.',
    setUp: 'TRS is set up 15 to 20 metres in front of goal. Goalkeeper stands in front of goal. Attacker stands other side of TRS.'
  },
  drillFour: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus three.',
    suitability: 'All standards.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To have the goalkeeper perform a separate task before immediately having to defend his goal with the reduction in available reaction time because of restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination.',
    setUp: 'TRS is set up 15 to 20 metres in front of goal. Goalkeeper stands in front of goal. A stands other side of TRS. B and C stand 8 to 10 meters from either end of the screen.'
  },
  drillFive: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus three.',
    suitability: 'More advanced standard.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'Attacker to react to ball coming to him through the screen and goalkeeper to defend goal with the reduction in available reaction time because of restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination, taking the ball on the torso for quicker responses.',
    setUp: 'TRS is set up 15 to 20 metres in front of goal. Goalkeeper stands in front of goal. A stands other side of TRS. B & C stand on the goal side a few metres back from each end of the screen.'
  },
  drillSix: {
    equipmentRequired: 'Goal, Two TRS, Footballs.',
    participantNumber: 'Goalkeeper plus two.',
    suitability: 'More advanced standards.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To take the goalkeeper further outside his comfort zone by pressuring the goalkeeper with shots from different directions with the reduction in available reaction time because of restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination.',
    setUp: 'One TRS is set up 15 to 20 metres in front of goal. Second TRS is set up on angle to the goal on either side of TRS one. Goalkeeper stands in front of goal. A stands other side of TRS 1 and B stands other side of TRS 2.'
  },
  drillSeven: {
    equipmentRequired: 'Goal, Two TRS, Footballs.',
    participantNumber: 'Goalkeeper plus three.',
    suitability: 'More advanced standard.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To challenge the goalkeeper with shots from different directions with the reduction in available reaction time because of restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination.',
    setUp: 'TRS 1 is set up on a diagonal15 to 20 metres from the goal. TRS 2 is set up on a similar angle on the other side of the Goal. Goalkeeper stands in front of goal. A and B stand other side of each TRS. C stands midway between the two TRS.'
  },
  drillEight: {
    equipmentRequired: 'Goal, Two TRS, Footballs.',
    participantNumber: 'Goalkeeper plus four.',
    suitability: 'More advanced standard.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To have the goalkeeper perform a separate task before immediately having to defend his goal with the reduction in available reaction time because of restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination.',
    setUp: 'TRS 1 is set up 15 to 20 metres in front of goal. TRS 2 is set up at right angles to the goal about 10 metres from the goal post. Goalkeeper stands in front of goal. A stands other side of TRS 1. B stands other side of TRS 2. D stands far side of goal from TRS 2. E stands between TRS 1 and TRS 2.'
  },
  drillNine: {
    equipmentRequired: 'Goal, Three TRS, Footballs.',
    participantNumber: 'Goalkeeper plus three.',
    suitability: 'More advanced standard.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To challenge the goalkeeper with multiple shots from different directions with the reduction in available reaction time because of restricted vision.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination.',
    setUp: 'TRS 1 is set up 15 to 20 metres in front of goal. TRS 2 is set up one side of TRS 1 on a diagonal to the goal. TRS 3 is set up on the other side of TRS 1 on a diagonal to the goal. Goalkeeper stands in front of goal. A stands the other side of TRS 1, B stands other side of TRS 2 and C stands the other side of TRS 3.'
  },
  drillTen: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus five to ten.',
    suitability: 'More advanced standard.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To restrict A from seeing where the ball will come from and to react to the circumstances, to create distractions in front of goal, to have the goalkeeper defend in traffic with short sharp shots at goal.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination, short passing, placement.',
    setUp: 'TRS is set up 15 to 20 metres in front of goal. Goalkeeper stands in front of goal. A stands other side of TRS. B and C stand out to the side on the goal side of the TRS. D and E stand in similar positions between the goal and B & C.'
  },
  drillEleven: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus five to eight.',
    suitability: 'All other than beginners.',
    areaRequired: 'Up to twenty metres in front of the goal.',
    focus: 'To restrict A from seeing where the ball will come from and to react to the circumstances, to react quickly with heading the ball at the goal, to have the goalkeeper defend headers at goal.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination, heading, placement.',
    setUp: 'TRS is set up in proximity to the goal. Goalkeeper stands in front of goal. A stands other side of TRS. B and C stand out to the side on the goal side of the TRS.'
  },
  drillTwelve: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus three or more attackers plus two or more defenders.',
    suitability: 'Competent to advanced standard.',
    areaRequired: 'Up to fifteen metres in front of the goal and about 15 metres either side of the goal. (The drill is meant to resemble a corner shot so the TRS should be at least fifteen metres from the goal posts.)',
    focus: 'To kick the ball over the TRS to attackers in front of goal, to create distractions in front of goal, attackers to head or control the ball and kick at goal, to have the goalkeeper defend in traffic with short sharp shots or further headers at goal.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination, heading, short passing, placement, communication.',
    setUp: 'TRS is set up to side of goal. Goalkeeper stands in front of goal. A stands other side of TRS. B stands out to the side on the goal side of the TRS. The attackers and defenders take up various positions in front of goal.'
  },
  drillThirteen: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus three.',
    suitability: 'Competent to advanced standard.',
    areaRequired: 'Up to ten metres in front of the goal.',
    focus: 'To improve header skills in attackers, to have the goalkeeper defend headers.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination, heading, placement.',
    setUp: 'TRS is set up in close proximity to front of goal. Goalkeeper stands in front of goal. A stands other side of TRS. B and C stand five metres out to the side on each end of the TRS.'
  },
  drillFourteen: {
    equipmentRequired: 'Goal, TRS, Footballs.',
    participantNumber: 'Goalkeeper plus two defenders plus five to eight attackers.',
    suitability: 'Competent to advanced standard.',
    areaRequired: 'Up to ten metres in front of the goal.',
    focus: 'To control direction and placement of headers, to generate options in front of goal, to create distractions in front of goal, to generate communication and understanding between goalkeeper and defenders, to have the goalkeeper defend in traffic with short sharp shots at goal.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching/deflecting the ball, hand eye coordination, short passing, heading, communication, coordinating defensive strategies, placement.',
    setUp: 'TRS is set up in proximity to the front of goal. Goalkeeper stands in front of goal. A stands other side of TRS. B and C stand out to the side off each end of the TRS. The defenders take up position in front of and to either side of the Goalkeeper.'
  }
};

const FormattedRequirement = ({ exercise }: FormattedRequirementProps) => {
  let req = requirements[exercise];

  return (
    <p>
      <strong>Equipment required:</strong> {req.equipmentRequired}<br />
      <strong>Number of Participants:</strong> {req.participantNumber}<br />
      <strong>Standard suitability:</strong> {req.suitability}<br />
      <strong>Area Required:</strong> {req.areaRequired}<br />
      <strong>Focus:</strong> {req.focus}<br />
      <strong>Skills Involved:</strong> {req.skillsInvolved}<br />
      <strong>Set Up:</strong> {req.setUp}
    </p>
  )
};

export {
  FormattedRequirement,
};
